import { transparentize } from 'polished';
import styled, { css } from 'styled-components';

interface IFeatures {
  posX: string;
  posY: string;
}

interface IButton {
  label?: string;
}

export const OpButton = styled.button<IButton>`
  ${( {label, theme} ) => css`
      position: relative;
      white-space: nowrap; 
      border: 1px solid ${theme.colors.black};
      color: ${theme.colors.black};
      font-family: ${theme.font.family.default};
      background-color: ${theme.colors.white};
      border-radius: 5px;
      transition: 0.5s;
      font-weight: ${theme.font.weights.medium};
      font-size: ${theme.font.sizes.sm};

      &:hover {
        background-color: ${theme.colors.blue100};
      }
      z-index: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 5px;
      
      @media (max-width: 1600px) {
        height: 27px;
        width: 100px;
      }

      @media (max-width: 535px) {
        height: 22px;
        width: 75px;
      }

      ${ label && `
        &:hover {
          &::before {
            bottom: 30px;
            opacity: 1;
          }
        }

        &::before {
          width: 120px;
          white-space: normal;

          content: '${label}';
          padding: ${theme.spacings[6]};
          position: absolute;
          bottom: 0px;
          pointer-events: none;

          font-size: ${theme.font.sizes.xs};
          font-weight: ${theme.font.weights.bold};

          border-radius: 0.4rem;

          background-color: ${theme.colors.black};
          color: ${theme.colors.white};

          opacity: 0;
          transition: all 0.2s;
        }
      `}
      .operator-info {
        font-size: ${theme.font.sizes.xs};
        position: absolute;
        right: 5px;
        top: 5px
      }
  `}
`;

export const Wrapper = styled.div`
  ${({ theme }) => css`
    position: fixed;
    bottom: 25%;
    z-index: 10;
    display: flex;
    right: calc(50% - 275px);

    p {
      font-family: ${theme.font.family.default};
    }

    @media (max-width: 1680px) {
      right: calc(50% - 300px);
    }

    @media (max-width: 1440px) {
      right: calc(50% - 325px);
    }

    @media (max-width: 1280px) {
      right: calc(50% - 405px);
    }
  `}
`;

export const Modal = styled.div`
  ${() => css`
    display: inline-block;
  `}
`;

export const Features = styled.div<IFeatures>`
  ${({ theme, posX, posY }) => css`
    display: inline-block;
    position: fixed;
    top: ${posY};
    left: ${posX};
    display: flex;

    p {
      font-family: ${theme.font.family.default};
    }
  `}
`;

export const Loading = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 100%;

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: ${transparentize(0.9, theme.colors.black)};

    cursor: progress;
  `}
`;

export const Content = styled.div`
  ${({ theme }) => css`
    width: 100%;
    height: 538px;
    border: 1px solid black;
    padding: 5px;

    .error-msg {
      font-size: ${theme.font.sizes.xl};
      font-weight: ${theme.font.weights.bold};

      display: flex;
      position: relative;
      justify-content: center;
      align-items: center;

      padding: 10px;
      width: 100%;
      height: 495px;
      justify-content: center;
    }

    .watermark {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      font-size: 300px;
      opacity: 0.08;
      pointer-events: none;
    }

    *::-webkit-scrollbar {
      width: 0.8rem;
      background-color: ${theme.colors.gray200};
      border-radius: ${theme.radius.xs};
    }

    *::-webkit-scrollbar-thumb {
      background-color: ${transparentize(0.5, theme.colors.indigo800)};
    }

    .title {
      font-weight: ${theme.font.weights.bold};
      font-size: ${theme.font.sizes.lg};
    }

    .tab-wrapper {
      display: flex;
      justify-content: space-between;
      // gap: 10px;
      margin-bottom: 5px;
    }

    .tab-button {
      padding: ${theme.spacings[4]};
      background-color: ${theme.colors.blue600};
      width: 100%;
      font-size: ${theme.font.sizes.md};
      font-weight: ${theme.font.weights.bold};
    }
    
    .values-wrapper {
      width: 100%;
      display: flex;
      gap: 10px;
      .notFound {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;
        color: ${theme.colors.gray600};
        font-weight: ${theme.font.weights.bold};
      }
    }
    
    .field-wrapper {
      width: 100%;
      flex: 1;
    }

    .field-input {
      display: flex;
      flex-direction: column;
      border: 1px solid black;
      height: 200px;
      overflow: hidden;

      .values {
        overflow: scroll;
        overflow-x: hidden;
        height: 100%;

        .value-row {
          transition: 0.5s;
          &:hover {
            background-color: ${theme.colors.blue100} !important;
          }
        }
      }

      .input-wrapper {
        padding: 2px;
        border-bottom: 1px solid black;
        position: relative;
        .search-icon {
          position: absolute;
          left: 6px;
          top: 48%;
          transform: translateY(-50%);
          font-size: ${theme.font.sizes.sm};
          line-height: normal;

        }
        .search-input {
          width: 100%;
          padding: 2px;
          padding-left: 20px;
        }
      }
    }

    .operator-input {
      border: 1px solid black;
      height: 75px;
    }

    .operator-field {
      margin-top: 10px;
    }

    .operators {
      display: grid;
      grid-template-columns: repeat(6, 1fr);
      grid-template-rows: repeat(2, auto);
      gap: 5px;
      padding: 5px;
      place-items: center;
    }

    .modal-footer {
      width: 100%;
      padding: 10px 0 0 0;
      display: flex;
      justify-content: flex-end;
    }

    .text-area {
      width: 100%;
      height: 100%;
      padding: 5px;
      resize: none;
      border: none;
      font-size: ${theme.font.sizes.xs};
      font-weight: ${theme.font.weights.medium};
    }

    .button-wrapper {
      display: flex;
      width: 300px;
      height: 40px;
      gap: 10px;

      .button {
        width: 100%;
        height: 100%;
        padding-left: 0;
        padding-right: 0;
      }

      .clear {
        border: 1px solid ${theme.colors.black};
        color: ${theme.colors.black};
        background-color: ${theme.colors.white};
        transition: 0.5s;

        &:hover {
          background-color: ${theme.colors.gray100};
          color: ${theme.colors.error};
        }
      }
    }
  `}
`;
